// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"vZ-z","subtitle":"wZ-z","wrapper":"xZ-z","leftArrow":"yZ-z","rightArrow":"zZ-z"};